 import { combineReducers } from "redux";
import {
	errorsReducer as errors,
	successesReducer as successes,
	apiStatusReducer as apiCallsInProgress
} from "@prominentmedia/coreredux";
import { loggedInUserDetailsReducer as loggedInUserDetails } from "@prominentmedia/redux-auth";
import sidebarShow from "./sidebarShowReducer";
import sidebarNavItems from "./sidebarNavItemsReducer";
import types from "../actions/actionTypes";
import engineerReports from "./engineerReportsReducer";
import usersList from "./usersListReducer";
import users from "./usersReducer";
import userListUpdateRequired from "./userListUpdateRequiredReducer";

//https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store

import projectPhasesTableOpen from "./projectPhasesTableOpenReducer";
import projectInvoicesTableOpen from "./projectInvoicesTableOpenReducer";
import showCompleteProjects from "./showCompleteProjectsReducer";
import contactsList from "./contactsListReducer";
import contacts from "./contactsReducer";
import contactListUpdateRequired from "./contactListUpdateRequiredReducer";
import organisationsList from "./organisationsListReducer";
import organisations from "./organisationsReducer";
import organisationListUpdateRequired from "./organisationListUpdateRequiredReducer";
import organisationIdsNeedingUpdate from "./organisationIdsNeedingUpdateReducer";
import phases from "./phasesReducer";
import projectsList from "./projectsListReducer";
import projects from "./projectsReducer";
import projectListUpdateRequired from "./projectListUpdateRequiredReducer";
import projectsIdsNeedingUpdate from "./projectsIdsNeedingUpdateReducer";
import projectsWithPhasesList from "./projectsWithPhasesListReducer";
import projectItems from "./projectItemsReducer";
import projectItemIdsNeedingUpdate from "./projectItemIdsNeedingUpdateReducer";
import projectItemActivitys from "./projectItemActivitysReducer";
import projectItemMilestones from "./projectItemMilestonesReducer";    
import projectItemStatussList from "./projectItemStatussListReducer";
import projectItemTypesList from "./projectItemTypesListReducer";
import projectTypesList from "./projectTypesListReducer";
import sitesList from "./sitesListReducer";
import sites from "./sitesReducer";
import siteListUpdateRequired from "./siteListUpdateRequiredReducer";

//https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store

import milestoneTemplateIdsNeedingUpdate from "./milestoneTemplateIdsNeedingUpdateReducer";
import milestoneTemplatesList from "./milestoneTemplatesListReducer";
import milestoneTemplates from "./milestoneTemplatesReducer";
import milestoneTemplateListUpdateRequired from "./milestoneTemplateListUpdateRequiredReducer";
import milestoneTemplateEntrys from "./milestoneTemplateEntrysReducer";

const appReducer = combineReducers({
	loggedInUserDetails
,sidebarShow
, sidebarNavItems
, showCompleteProjects
,apiCallsInProgress
,errors
,successes
, usersList
, engineerReports
,users
, userListUpdateRequired
, projectPhasesTableOpen
, projectInvoicesTableOpen
,contactsList
,contacts
,contactListUpdateRequired
,organisationsList
,organisations
,organisationListUpdateRequired
,organisationIdsNeedingUpdate
,phases
, projectsList
,projects
, projectListUpdateRequired
, projectsIdsNeedingUpdate
, projectsWithPhasesList
, projectItems
, projectItemIdsNeedingUpdate
,projectItemActivitys
,projectItemMilestones
,projectItemStatussList
,projectItemTypesList
,projectTypesList
,sitesList
,sites
,siteListUpdateRequired	
, milestoneTemplatesList
, milestoneTemplateIdsNeedingUpdate
,milestoneTemplates
,milestoneTemplateListUpdateRequired
,milestoneTemplateEntrys
});


const rootReducer = (state, action) => {
	if (action.type === types.USER_LOGOUT) {
		state = undefined;
	}

	return appReducer(state, action);
};

export default rootReducer;

